import { Link } from "react-router-dom";
import { SpurwechselLogo } from "@/components/SpurwechselLogo";

export default function AGBPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="agb-page">
      <nav className="glass-nav sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center h-16">
          <Link to="/" className="flex items-center gap-2">
            <SpurwechselLogo size="small" />
          </Link>
        </div>
      </nav>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-8">Allgemeine Geschäftsbedingungen (AGB)</h1>
        <div className="prose prose-stone font-body text-sm leading-relaxed space-y-6">
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 1 Geltungsbereich</h2>
            <p className="text-muted-foreground">Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Plattform Spurwechsel PRO (nachfolgend "Dienst"), betrieben von Subyr Fayazi (nachfolgend "Anbieter"). Mit der Registrierung akzeptiert der Nutzer diese AGB.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 2 Leistungsbeschreibung</h2>
            <p className="text-muted-foreground">Spurwechsel PRO ist ein digitales Übungswerkzeug zur Vorbereitung auf das psychologische Gespräch der Medizinisch-Psychologischen Untersuchung (MPU). Der Dienst umfasst:</p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>KI-gestützte Übungsgespräche zur Simulation des MPU-Gesprächs</li>
              <li>Analyse und Feedback zu Gesprächsverläufen</li>
              <li>Einen strukturierten Lernpfad mit verschiedenen Schwierigkeitsstufen</li>
              <li>Dokumente und Wissensressourcen zur MPU-Vorbereitung</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 3 Wichtige Einschränkungen</h2>
            <p className="text-muted-foreground font-semibold">Der Dienst ist ausdrücklich KEIN Ersatz für:</p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>Eine professionelle MPU-Beratung durch eine anerkannte Beratungsstelle</li>
              <li>Psychologische Therapie oder Beratung</li>
              <li>Rechtsberatung</li>
              <li>Eine medizinische Behandlung</li>
            </ul>
            <p className="text-muted-foreground mt-2">Die Nutzung des Dienstes garantiert nicht das Bestehen der MPU. Die KI-generierten Gespräche und Analysen dienen ausschließlich Übungszwecken.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 4 Registrierung und Nutzerkonto</h2>
            <p className="text-muted-foreground">Für die Nutzung ist eine Registrierung erforderlich. Der Nutzer ist verpflichtet, wahrheitsgemäße Angaben zu machen und seine Zugangsdaten vertraulich zu behandeln. Jede Person darf nur ein Konto erstellen.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 5 Kostenlose und kostenpflichtige Leistungen</h2>
            <p className="text-muted-foreground">Der Dienst bietet einen kostenlosen Zugang mit begrenztem Funktionsumfang (3 Sessions). Erweiterte Funktionen sind über kostenpflichtige Pläne verfügbar. Die aktuellen Preise sind auf der Preisseite einsehbar. Alle Preise verstehen sich inklusive der gesetzlichen Mehrwertsteuer.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 6 Zahlungsbedingungen</h2>
            <p className="text-muted-foreground">Die Zahlung erfolgt über den Zahlungsdienstleister Stripe. Mit dem Kauf eines Plans akzeptiert der Nutzer die Zahlungsbedingungen von Stripe. Die Zahlung ist bei Kaufabschluss fällig. Es handelt sich um Einmalzahlungen, nicht um Abonnements.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 7 Widerrufsrecht</h2>
            <p className="text-muted-foreground">Als Verbraucher haben Sie ein 14-tägiges Widerrufsrecht ab Kaufdatum. Der Widerruf kann per E-Mail an info@spurwechsel-pro.de erklärt werden. Bei digitalen Inhalten, die sofort nach dem Kauf bereitgestellt werden, kann das Widerrufsrecht vorzeitig erlöschen, wenn Sie dem ausdrücklich zugestimmt haben.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 8 Datenschutz</h2>
            <p className="text-muted-foreground">Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer <Link to="/privacy" className="text-primary hover:underline">Datenschutzerklärung</Link>. Der Nutzer kann sein Konto und alle personenbezogenen Daten jederzeit vollständig löschen.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 9 Nutzungsregeln</h2>
            <p className="text-muted-foreground">Der Nutzer verpflichtet sich:</p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>Den Dienst nicht missbräuchlich zu verwenden</li>
              <li>Keine automatisierten Zugriffe (Bots) einzusetzen</li>
              <li>Keine rechtswidrigen oder beleidigenden Inhalte einzugeben</li>
              <li>Die Ergebnisse nicht als professionelle Gutachten oder Beratung darzustellen</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 10 Haftung</h2>
            <p className="text-muted-foreground">Der Anbieter haftet nicht für Schäden, die aus der Nutzung des Dienstes entstehen, insbesondere nicht für das Ergebnis einer MPU. Die Haftung für Vorsatz und grobe Fahrlässigkeit bleibt unberührt. Die Haftung ist auf den Kaufpreis des jeweiligen Plans begrenzt.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 11 Verfügbarkeit</h2>
            <p className="text-muted-foreground">Der Anbieter bemüht sich um eine hohe Verfügbarkeit des Dienstes, kann diese jedoch nicht garantieren. Wartungsarbeiten und technische Störungen können die Verfügbarkeit einschränken. Bei KI-bedingten Ausfällen werden alternative Inhalte bereitgestellt.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 12 Kündigung</h2>
            <p className="text-muted-foreground">Kostenpflichtige Pläne haben eine feste Laufzeit und verlängern sich nicht automatisch. Der Nutzer kann sein Konto jederzeit löschen. Der Anbieter behält sich das Recht vor, Nutzerkonten bei Verstoß gegen diese AGB zu sperren.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 13 Änderungen der AGB</h2>
            <p className="text-muted-foreground">Der Anbieter behält sich vor, diese AGB zu ändern. Wesentliche Änderungen werden den Nutzern per E-Mail mitgeteilt. Die fortgesetzte Nutzung nach Mitteilung gilt als Zustimmung.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">§ 14 Schlussbestimmungen</h2>
            <p className="text-muted-foreground">Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt.</p>
          </section>

          <section className="border-t border-border pt-4">
            <p className="text-muted-foreground text-xs">Stand: Februar 2026</p>
          </section>
        </div>
      </div>
    </div>
  );
}
